<script>
  import { formatBytes } from '@common/utils/numbers';

  export let row = {};
</script>

{formatBytes(row.filesize)}
